import styled from 'styled-components';

const Container = styled.div<{ $narrow?: boolean }>`
  width: 100%;
  max-width: calc(${({ $narrow }) => ($narrow ? '880px' : 'var(--container)')} + 2 * var(--gutter));
  margin: 0 auto;
  padding: 0 var(--gutter);
`;

export default Container;
